import { IndentedRadioGroup } from 'components/form'
import { P } from '@farewill/ui'

export const PROBATE_CASE_TYPE_FILTER_OPTIONS: {
  label: string
  value: string
}[] = [
  { value: 'all', label: 'All Cases' },
  { value: 'essential', label: 'Essential Probate' },
  { value: 'complete', label: 'Complete Probate' },
]

export const ProbateCaseTypeFilter = () => (
  <>
    <P size="S" strong>
      Case type
    </P>
    <IndentedRadioGroup
      name="probateCaseType"
      options={PROBATE_CASE_TYPE_FILTER_OPTIONS}
    />
  </>
)
